import TextField from '@/components/ui/form-inputs/TextField';
import RemovableTextField from '@/components/ui/removable-text-field';
import { SITE_FORM_KEY } from '@/shared/constants/form-keys';
import { Box } from '@mui/material';
import { ChangeEvent, FunctionComponent, ReactElement } from 'react';

interface LevelTextFieldProps {
	name: string;
	level: string;
	label: string;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	isRemovable?: boolean;
	onRemove?: () => void;
}

const LevelTextField: FunctionComponent<LevelTextFieldProps> = ({
	level,
	name,
	label,
	onChange,
	isRemovable,
	onRemove,
}): ReactElement => {
	const containerWidth = isRemovable ? '396px' : '360px';
	const props = {
		name,
		onChange,
		label,
		value: level,
		formKey: SITE_FORM_KEY,
		fullWidth: true,
		...(isRemovable ? { onRemove } : {}),
	};
	return (
		<Box sx={{ width: containerWidth }}>
			{isRemovable ? <RemovableTextField {...props} /> : <TextField {...props} />}
		</Box>
	);
};

export default LevelTextField;
